import request from '@/utils/request'

export const getMaterialmanageList = ({ page, size, keywords: recordCode }) => {
  return request({
    url: `/trace/materialmanage/${page}/${size}`,
    params: {
      recordCode
    }
  })
}

export const postMaterialmanageEdit = (data) => {
  return request({
    method: 'post',
    url: '/trace/materialmanage',
    data
  })
}

export const putMaterialmanageAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/materialmanage',
    data
  })
}

export const getMaterialmanageDetail = (id) => {
  return request({
    url: `/trace/materialmanage/${id}`
  })
}

export const deleteMaterialmanageDel = (id) => {
  return request({
    method: 'delete',
    url: `/trace/materialmanage/${id}`
  })
}

export const delMaterialmanageList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/materialmanage/all',
    data
  })
}
